import {
  MonitoredCounter,
  MonitoredCounterCreateRequest,
  MonitoredCounterUpdateRequest,
} from '../../types/app/monitoredCounter.types';
import { api } from '../core/api';

export const getMonitoredCountersByDep = (departmentId: number) =>
  api
    .get<MonitoredCounter[]>(`MonitoredCounter/GetList/?parentId=${departmentId}`)
    .then((res) => res.data);

export const getMonitoredCounter = (id: number) =>
  api.get<MonitoredCounter>(`MonitoredCounter/GetItem/?id=${id}`).then((res) => res.data);

export const updateMonitoredCounter = (data: MonitoredCounterUpdateRequest) =>
  api.put(`MonitoredCounter/UpdateItem`, data).then((res) => res.data);

export const createMonitoredCounter = (data: MonitoredCounterCreateRequest) =>
  api.post(`MonitoredCounter/CreateItem`, data).then((res) => res.data);

export const deleteMonitoredCounter = (id: number) =>
  api.delete<MonitoredCounter>(`MonitoredCounter/DeleteItem/?id=${id}`).then();

export const getCount = (parentId?: number) =>
  api
    .get<number>(`MonitoredCounter/GetCount` + (parentId ? `?parentId=${parentId}` : ''))
    .then((res) => res.data);
